/* eslint-disable indent */
import styled from 'styled-components';
import DefaultCard from 'containers/Card';

const Card = styled(DefaultCard)`
    header {
        border-bottom: 1px solid var(--color-gray-200);
    }

    @media print {
        display: block;
        height: auto;
        max-width: none;
        width: auto;

        header { display: none; }

        .print-preview-body {
            display: block;
            height: auto;
            overflow: visible;
        }
    }
`;

export default Card;
